/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Paypal_Webhook_IdInputs */

const en_admin_settings_fields_paypal_webhook_id = /** @type {(inputs: Admin_Settings_Fields_Paypal_Webhook_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhook ID`)
};

const zh_admin_settings_fields_paypal_webhook_id = /** @type {(inputs: Admin_Settings_Fields_Paypal_Webhook_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhook ID`)
};

/**
* | output |
* | --- |
* | "Webhook ID" |
*
* @param {Admin_Settings_Fields_Paypal_Webhook_IdInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_paypal_webhook_id = /** @type {((inputs?: Admin_Settings_Fields_Paypal_Webhook_IdInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Paypal_Webhook_IdInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_paypal_webhook_id(inputs)
	return zh_admin_settings_fields_paypal_webhook_id(inputs)
});
export { admin_settings_fields_paypal_webhook_id as "admin.settings.fields.paypal_webhook_id" }